module.exports = __webpack_public_path__ + "img/3-6.0edf8d1e.png";